import React, { MouseEvent, ReactElement } from 'react';
import { useSelector } from '@ecommerce/nest-ssr/common';
import Badge from 'atomic/utilization/badge';

import './delivery.scss';

declare const window: any;

const Delivery: React.FC<{
    className?: string;
    freeDelivery: boolean | undefined;
    dealerId: number;
}> = ({ className, freeDelivery, dealerId }): ReactElement => {
    const departmentId: number = useSelector((state: { departmentId: number; }) => state.departmentId);
    const productId: number = useSelector((state: { productId: number; }) => state.productId);
    const isAmazon = dealerId === 11083;

    const openInNewWindow = (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>): boolean => {
        window.open((e.target as any).getAttribute('data-url'), '_blank', 'resizable=yes,height=700,width=700');

        return false;
    };

    if (freeDelivery) {
        return (
            <Badge className={`${className || ''}`} color="green" size="xs"
                outline={true} weight="600"
            >
                Darmowa dostawa
            </Badge>
        );
    }

    return (
        <button
            type="button"
            onClick={openInNewWindow}
            data-url={isAmazon
                ? 'https://www.amazon.de/gp/help/customer/display.html?nodeId=201910850'
                + '#GUID-94F272E0-F280-4956-87FB-E99C2528462A__SECTION_3C6C049466B041B08CCA2A57FF285314'
                : `/delivery.php?d=${dealerId}&cp=${productId}&dp=${departmentId}`}
            className={`${className || ''} delivery-cost link gtm_oa_shipping`}
            data-action="offer/deliveryCosts"
        >
            + koszty dostawy
        </button>
    );
};

export default Delivery;
